import Vue from 'vue'
import { USER_INFO, ENHANCE_PRE } from "@/store/mutation-types"
const getters = {
  device: state => state.app.device,
  theme: state => state.app.theme,
  color: state => state.app.color,
  token: state => state.user.token,
  avatar: state => { state.user.avatar = Vue.ls.get(USER_INFO).avatar; return state.user.avatar },
  username: state => state.user.info.username,
  userId: state => state.user.userId,

  nickname: state => { state.user.info.realname = Vue.ls.get(USER_INFO).realname; return state.user.info.realname },
  welcome: state => state.user.welcome,
  permissionList: state => state.user.permissionList,
  benchData: state => state.workbench.benchData,
  layoutList: state => state.workbench.layoutList,
  userRoutes: state => state.user.routes,
  quickMenu: state => state.user.quickMenu,
  routeList: state => state.workbench.routeList,
  userInfo: state => { state.user.info = Vue.ls.get(USER_INFO); return state.user.info },
  addRouters: state => state.permission.addRouters,
  onlAuthFields: state => { return state.online.authFields },
  enhanceJs: (state) => (code) => {
    state.enhance.enhanceJs[code] = Vue.ls.get(ENHANCE_PRE + code);
    return state.enhance.enhanceJs[code]
  },
  sysSafeMode: state => state.user.sysSafeMode,
  detailMap: state => state.user.detailMap,
  reportTabs: state => state.reportTab.tabList,
  tabActiveCode: state => state.reportTab.activeCode,//state => state.reportTabs.activeCode
  defaultHomeIndex: state => state.user.defaultHomeIndex
}

export default getters
